const WaitingForApprovalIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" rx="4" fill="#FFF2C4" />
      <g clip-path="url(#clip0_16534_41427)">
        <path
          d="M19.3333 16H16V11"
          stroke="#FFC700"
          stroke-width="1.25"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M24.3334 16.0001C24.3334 20.6024 20.6024 24.3334 16.0001 24.3334C11.3977 24.3334 7.66675 20.6024 7.66675 16.0001C7.66675 11.3977 11.3977 7.66675 16.0001 7.66675"
          stroke="#FFC700"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M21.7063 9.47542C21.8514 9.60358 21.9926 9.73636 22.1296 9.87341C22.2666 10.0105 22.3993 10.1518 22.5273 10.297M18.5 7.66675C18.9018 7.78554 19.2957 7.9387 19.6778 8.12228M23.8646 12.2956C24.0539 12.686 24.2116 13.0889 24.3333 13.5001"
          stroke="#FFC700"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_16534_41427">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(6 6)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default WaitingForApprovalIcon;
